// extracted by mini-css-extract-plugin
export var actionText = "_ls-4";
export var container = "_ls-0";
export var leftSection = "_ls-1";
export var rightSection = "_ls-2";
export var settingsButton = "_ls-6";
export var settingsIcon = "_ls-7";
export var shortcut = "_ls-5";
export var shortcutGroup = "_ls-3";